import styled from "styled-components";

export const FlexTextEllipsis = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;